import { render, staticRenderFns } from "./DocumentFileCategories.vue?vue&type=template&id=cb63efda&scoped=true"
import script from "./DocumentFileCategories.vue?vue&type=script&lang=js"
export * from "./DocumentFileCategories.vue?vue&type=script&lang=js"
import style0 from "./DocumentFileCategories.vue?vue&type=style&index=0&id=cb63efda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb63efda",
  null
  
)

export default component.exports